// CategoryCarousel.jsx
import React, { useEffect, useState } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import './styles/CategoryCarousel.css';
import CategoryBox from './CategoryBox';

const CategoryCarousel = ({ categories }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState('next');

  useEffect(() => {
    console.log(categories);
  }, []);

  const handleNext = () => {
    setDirection('next');
    setCurrentIndex((prev) => (prev + 1) % categories.length);
  };

  const handlePrev = () => {
    setDirection('prev');
    setCurrentIndex((prev) => (prev - 1 + categories.length) % categories.length);
  };

  const getCardPosition = (index) => {
    const diff = (index - currentIndex + categories.length) % categories.length;
    if (diff === 0) return 'active';
    if (diff === 1 || diff === -categories.length + 1) return 'next';
    if (diff === -1 || diff === categories.length - 1) return 'prev';
    if (diff === 2 || diff === categories.length - 2) return 'notshown';
    return 'hidden';
  };

  return (
    <div className="carousel-container">
      <div className="carousel-wrapper">
        {categories.map((category, index) => (
          <CategoryBox
            key={index}
            category={category}
            position={getCardPosition(index)}
          />
        ))}
      </div>

      <div className="carousel-controls">
        <button onClick={handlePrev} className="carousel-button">
          <svg 
            className="w-6 h-6 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
        <button onClick={handleNext} className="carousel-button">
          <svg
            className="w-6 h-6 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default CategoryCarousel;